import { render } from "./bazipaipan.vue?vue&type=template&id=fdc114fa"
import script from "./bazipaipan.vue?vue&type=script&lang=js"
export * from "./bazipaipan.vue?vue&type=script&lang=js"

import "./bazipaipan.vue?vue&type=style&index=0&id=fdc114fa&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__